import React from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import { segment } from '@leadhome/utils';
import { LeftArrowIcon, RightArrowIcon } from './styles';
import ProgressiveImage from '@oxygen/ab/ProgressiveImage';

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
    >
      <RightArrowIcon />
    </button>
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
    >
      <LeftArrowIcon />
    </button>
  );
}

const sliderConfig = {
  speed: 500,
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  draggable: true,
  slidesToScroll: 1,
  lazyLoad: 'ondemand',
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  afterChange: function () {
    segment.track('PropertySearch: PropertyCardCarousel');
  }
};

const Carousel = ({ id, images, alt }) => {
  return (
    <Slider {...sliderConfig}>
      {images.map((image, index) => (
        <ProgressiveImage
          key={`img_${id}_${index}`}
          src={image?.medium}
          alt={alt}
          layout='responsive'
          height={513}
          width={770}
        />
      ))}
    </Slider>
  );
};

Carousel.propTypes = {
  images: PropTypes.array.isRequired
};

export default React.memo(Carousel);
